import { AnimatePresence, motion } from "motion/react"
import { ReactNode } from "react"
import { IconCheck } from "./Icon"
import { cn } from "@utils/tw"

type Props = {
  label?: ReactNode
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  className?: string
}

export function Checkbox(props: Props) {
  return (
    <label className={cn("flex items-center gap-[0.7em] type-label-m cursor-pointer", props.className)}>
      <input
        className="hidden"
        type="checkbox"
        checked={props.checked}
        onChange={(e) => props.onCheckedChange(e.target.checked)}
      />
      <span className="size-[1.4em] flex items-center justify-center border rounded-xs">
        <motion.div
          variants={{ checked: { scale: 1 }, unchecked: { scale: 0 } }}
          initial="unchecked"
          animate={props.checked ? "checked" : "unchecked"}
          exit="unchecked"
          className="flex items-center justify-center"
        >
          <IconCheck className="size-[1em]" />
        </motion.div>
      </span>
      {props.label && <span>{props.label}</span>}
    </label>
  )
}
